import { useEffect, useState, useMemo } from "react";
import { PlusCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Spin, Modal, message, Button, Menu, Dropdown } from "antd";
import TableComponent from "../../components/TableComponent";
import { API_ENDPOINTS } from "../../utils/constants";
import { axiosInstance } from "../../utils/axiosInstance";
import { createColumn } from "../../utils/tableUtils";
import { useNavigate } from "react-router-dom";
import MainButtonComponent from "../../components/MainButtonComponent";
import {
	HeaderComponent,
	Container,
	ContainerHeader,
	ActionButtonComponent,
	StatusCell
} from "./styles";
import { AxiosResponse } from "axios";
import { useDiscoveryContext } from "../../context/DiscoveryContext/DiscoveryContext";

interface Discovery {
	discoveryId: string;
	title: string;
	displayOrder: number;
	isVisible: boolean;
}
interface DiscoveryListApiResponse {
	result: {
		items: Discovery[];
	};
	error: string | null;
	isSuccessful: boolean;
}

const DiscoveryList = () => {
	const [tableData, setTableData] = useState<any[]>([]);
	const [pageLoading, setPageLoading] = useState(true);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentItem, setCurrentItem] = useState<any>(null);
	const { clearData } = useDiscoveryContext();


	const navigate = useNavigate();

	const getDiscoveryList = async () => {
		setPageLoading(true);
		try {
			const response: AxiosResponse<DiscoveryListApiResponse> = await axiosInstance.get(
				API_ENDPOINTS.GET_DISCOVERY_LIST
			);
			setTableData(response.data.result.items);
		} catch (error) {
			return [[], false];
		} finally {
			setPageLoading(false);
		}
	};

	const handleDelete = async (discoveryId: string) => {
		try {
			await axiosInstance.post(API_ENDPOINTS.REMOVE_DISCOVERY, { discoveryId });
			message.success("İçerik başarıyla silindi.");
			getDiscoveryList();
		} catch (error) {
			message.error("İçerik silinirken bir hata oluştu.");
		} finally {
			setIsModalVisible(false);
		}
	};

	useEffect(() => {
		getDiscoveryList();
		clearData();
	}, []);

	const columns = useMemo(() => [
		createColumn({
			title: "Sıra",
			dataIndex: "displayOrder",
			width: 30,
			sorterType: "numeric",
		}),
		createColumn({
			title: "Başlık",
			dataIndex: "title",
			width: 300,
			sorterType: "string",
		}),
		createColumn({
			title: "Durum",
			dataIndex: "isVisibleStatus",
			width: 50,
			sorterType: "string",
			render: (text, record) => (
				<StatusCell $isVisible={!record.isVisible}>{!record.isVisible ? "Pasif" : "Aktif"}</StatusCell>
			),
		}),
		createColumn({
			title: "",
			dataIndex: "action",
			width: 20,
			render: (text, record) => {
				const menu = (
					<Menu>
						<Menu.Item key="edit" onClick={() => navigate(`/edit-discovery/${record.discoveryId}`)}>
							Güncelle
						</Menu.Item>
						<Menu.Item key="delete" onClick={() => {
							setCurrentItem(record);
							setIsModalVisible(true);
						}}>
							Sil
						</Menu.Item>
					</Menu>
				);
				return (
					<Dropdown overlay={menu} trigger={["click"]}>
						<MoreOutlined />
					</Dropdown>
				);
			}
		}),
	], [tableData]);

	return (
		<div>
			<HeaderComponent>Keşfet</HeaderComponent>
			<Container>
				<Spin spinning={pageLoading}>
					<ContainerHeader>
						<ActionButtonComponent>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<PlusCircleOutlined />}
								onClick={() => navigate(`/add-discovery`)}
							>
								Yeni Ekle
							</MainButtonComponent>
						</ActionButtonComponent>
					</ContainerHeader>
				</Spin>
				{!pageLoading && (
					<TableComponent
						columns={columns}
						dataSource={tableData}
					/>
				)}
			</Container>

			<Modal
				title="İçerik Sil"
				visible={isModalVisible}
				onOk={() => handleDelete(currentItem.discoveryId)}
				onCancel={() => setIsModalVisible(false)}
				okText="Evet"
				cancelText="Hayır"
				footer={[
					<Button key="back" type="text" onClick={() => setIsModalVisible(false)}>
						İptal
					</Button>,
					<Button
						key="submit"
						type="primary"
						danger
						onClick={() => handleDelete(currentItem.discoveryId)}
					>
						Evet
					</Button>,
				]}
			>
				<p><strong>{`"${currentItem?.title}"`}</strong> içeriğini silmek istediğinizden emin misiniz?</p>
			</Modal>
		</div>
	);
};

export default DiscoveryList;
